import type { ReactNode } from 'react';

import { ITEM_META, ITEM_TITLE, ROW_HOVER, THUMBNAIL_SQUARE } from '@/lib/ui-tokens';
import { cn } from '@/lib/utils';

interface PanelListRowProps {
  title: ReactNode;
  meta?: ReactNode;
  leading?: ReactNode;
  trailing?: ReactNode;
  onClick?: () => void;
  className?: string;
  titleClassName?: string;
  metaClassName?: string;
}

export function PanelListRow({
  title,
  meta,
  leading,
  trailing,
  onClick,
  className,
  titleClassName,
  metaClassName,
}: PanelListRowProps): JSX.Element {
  const content = (
    <>
      {leading ? <span className={THUMBNAIL_SQUARE}>{leading}</span> : null}
      <span className="min-w-0 flex-1">
        <span className={cn('block truncate', ITEM_TITLE, titleClassName)}>{title}</span>
        {meta ? (
          <span className={cn('mt-0.5 block truncate', ITEM_META, metaClassName)}>{meta}</span>
        ) : null}
      </span>
      {trailing ? <span className="shrink-0">{trailing}</span> : null}
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(
          'group flex w-full items-center gap-3 rounded-sm px-4 py-2.5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          ROW_HOVER,
          className,
        )}
      >
        {content}
      </button>
    );
  }

  return (
    <div className={cn('flex w-full items-center gap-3 rounded-sm px-4 py-2.5', className)}>
      {content}
    </div>
  );
}
